import { render, staticRenderFns } from "./Showroom.vue?vue&type=template&id=85dd4bd0&scoped=true"
import script from "./Showroom.vue?vue&type=script&lang=js"
export * from "./Showroom.vue?vue&type=script&lang=js"
import style0 from "./Showroom.vue?vue&type=style&index=0&id=85dd4bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd4bd0",
  null
  
)

export default component.exports